import { useCallback, useState } from 'react';
import { parseError } from '@/utils';
import { DormitoryHttp } from '@/services';

export type PreRegisterFormPayload = {
  dormitoryId: number;
  description: string;
};

export default function useDormitoryPreRegisterForm() {
  const [submiting, setSubmiting] = useState(false);
  const [submitError, setSubmitError] = useState<string>('');

  const submit = useCallback(async (data: PreRegisterFormPayload) => {
    setSubmiting(true);
    setSubmitError('');
    try {
      return await DormitoryHttp.createPreRegisterRequest(data);
    }
    catch (e) {
      const err = parseError(e);
      setSubmitError(err);
      throw new Error(err);
    }
    finally {
      setSubmiting(false);
    }
  }, []);

  return { submit, submiting, submitError };
}
